import type { Article } from "../lib/types";
import { formatAge } from "../lib/format";

interface Props {
  articles: Article[];
  selected: Set<string>;
  onToggleSelect: (id: string) => void;
  onArchive: (id: string) => void;
  onFavorite: (id: string, value: boolean) => void;
  onOpen: (a: Article) => void;
}

export function ArticleList({ articles, selected, onToggleSelect, onArchive, onFavorite, onOpen }: Props) {
  return (
    <ul class="list" role="list">
      {articles.map((a) => {
        const isSel = selected.has(a.id);
        return (
          <li class="list-item" key={a.id}>
            <input
              type="checkbox"
              checked={isSel}
              onChange={() => onToggleSelect(a.id)}
              aria-label={`Select ${a.title ?? a.url}`}
              style="margin-top: 6px;"
            />
            <a
              href={`#/articles/${a.id}`}
              class="grow"
              onClick={(e) => { e.preventDefault(); onOpen(a); }}
              style="text-decoration: none;"
            >
              <div class="title">{a.title ?? a.url}</div>
              <div class="meta">
                {a.site_name && <span>{a.site_name}</span>}
                {a.author && <span>· {a.author}</span>}
                <span>· {formatAge(a.saved_at)}</span>
                {a.read_at && <span>· read</span>}
                {a.extraction_status === "failed" && <span style="color: var(--danger);">· failed</span>}
                {a.extraction_status === "pending" && <span>· queued</span>}
              </div>
              {a.reading_progress > 0 && a.reading_progress < 1 && (
                <div class="progress"><span style={`width: ${Math.round(a.reading_progress * 100)}%`} /></div>
              )}
            </a>
            <div class="list-actions">
              <button
                class="icon ghost"
                onClick={() => onFavorite(a.id, !a.favorite)}
                aria-label={a.favorite ? "Unfavorite" : "Favorite"}
                title={a.favorite ? "Unfavorite" : "Favorite"}
              >
                {a.favorite ? "★" : "☆"}
              </button>
              <button
                class="icon ghost"
                onClick={() => onArchive(a.id)}
                aria-label="Archive"
                title="Archive"
              >
                ✓
              </button>
            </div>
          </li>
        );
      })}
    </ul>
  );
}
